/**
 * Alaska Gift — Shared utilities
 * Loaded globally via theme.liquid with defer.
 */

window.AlaskaUtils = window.AlaskaUtils || {};

/* ── Focus Trap (Dawn-inspired pattern) ─────────────────────── */

AlaskaUtils.trapFocus = function (container) {
  const FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function handler(e) {
    if (e.key !== 'Tab') return;
    const focusable = [...container.querySelectorAll(FOCUSABLE)].filter(
      el => el.offsetParent !== null
    );
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  container.addEventListener('keydown', handler);
  container._trapFocusHandler = handler;
};

AlaskaUtils.removeTrapFocus = function (container) {
  if (container._trapFocusHandler) {
    container.removeEventListener('keydown', container._trapFocusHandler);
    delete container._trapFocusHandler;
  }
};

/* ── Format Money ──────────────────────────────────────────── */

AlaskaUtils.formatMoney = function (cents) {
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents);
  }
  return '$' + (cents / 100).toFixed(2);
};

/* ── Debounce ───────────────────────────────────────────────── */

AlaskaUtils.debounce = function (fn, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
};

/* ── PubSub (lightweight event bus) ─────────────────────────── */

AlaskaUtils.pubsub = (() => {
  const events = {};
  return {
    on(event, callback) {
      (events[event] = events[event] || []).push(callback);
      return () => {
        events[event] = events[event].filter((cb) => cb !== callback);
      };
    },
    emit(event, data) {
      (events[event] || []).forEach((cb) => cb(data));
    },
  };
})();
